"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressViewWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var moment = require("moment");
var journey_services_1 = require("@athena-portal/journey-services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../commonFunctions");
var services_1 = require("@falcon/services");
var ChangeAddressModal_1 = require("./annual/home/mta/ChangeAddressModal");
var AddressViewWidget = /** @class */ (function (_super) {
    __extends(AddressViewWidget, _super);
    function AddressViewWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToChangeAddress = function () {
            var changeAddressJourneyLink = function (process) {
                switch (process) {
                    case services_1.INTERACTION_PROCESS_MTA.toString():
                        return "/journey/show/product/AnnualHomeInsurance/process/mtaChangeAddress/preset/".concat(_this.props.interaction._id);
                    case services_1.INTERACTION_PROCESS_RENEWAL.toString():
                        return "/journey/show/product/AnnualHomeInsurance/process/renewal/changeAddressPropertyDetails/".concat(_this.props.interaction._id);
                    default:
                        return "/journey/show/product/AnnualHomeInsurance/process/mtaSupportPortalAnnualHomeChangeAddress/preset/".concat(_this.props.interaction._id);
                }
            };
            window.location.assign(changeAddressJourneyLink(_this.props.interaction.process));
        };
        _this.state = {
            showWarningPopup: false
        };
        _this.toggleWarningPopUp = _this.toggleWarningPopUp.bind(_this);
        return _this;
    }
    AddressViewWidget.prototype.render = function () {
        var _this = this;
        if (!this.props.question.interactionField) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        var interaction = this.props.interaction;
        var uistate = interaction.uistate;
        var allowAddressChange = uistate.minMtaStartDate ? moment(uistate.maxMtaStartDate) >= moment(uistate.minMtaStartDate) : true;
        var address = journey_services_1.ObjectManipulator.fetchFieldValue(this.props.question.interactionField, this.props.interaction);
        var fullAddress = (0, commonFunctions_1.getAddressLines)(address)
            .map(function (line, index) {
            return (0, jsx_runtime_1.jsx)("div", { id: "address-line-" + index, children: line }, line);
        });
        var changesMade = uistate.interactionChangesDetected === true;
        return (0, jsx_runtime_1.jsxs)("div", { className: "property-details form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "address-display", children: this.props.question.label }), (0, jsx_runtime_1.jsx)(ChangeAddressModal_1.ChangeAddressModal, __assign({}, this.props, { isOpen: this.state.showWarningPopup, toggle: this.toggleWarningPopUp })), (0, jsx_runtime_1.jsx)("div", { className: "input-group", children: (0, jsx_runtime_1.jsxs)("div", { className: "address-display", id: "address-display", children: [fullAddress, (0, jsx_runtime_1.jsx)("button", { className: allowAddressChange ? "btn btn-default btn-back mb-3 mt-3" : "btn btn-disabled btn-primary mb-3 w-auto mt-4", type: "button", onClick: function (e) {
                                    if (changesMade) {
                                        e.preventDefault();
                                        _this.setState({ showWarningPopup: true });
                                    }
                                    else {
                                        _this.navigateToChangeAddress();
                                    }
                                }, children: "Change address" })] }) })] });
    };
    AddressViewWidget.prototype.toggleWarningPopUp = function () {
        this.setState(function (state) { return ({
            showWarningPopup: !state.showWarningPopup
        }); });
    };
    return AddressViewWidget;
}(plugin_journey_1.WidgetBase));
exports.AddressViewWidget = AddressViewWidget;
//# sourceMappingURL=AddressViewWidget.js.map